import React from "react";
import './use-case-features.css'

// ...... images .......
import interactive from '../../../../assets/images/intractive-purple.svg';
import insert from '../../../../assets/images/insert-call.svg';
import embed from '../../../../assets/images/embed-enywhere.svg';
import code from '../../../../assets/images/no-code.svg';

function UseCaseFeatures() {
   return(
       <div className="content-box width-1000">
          <div className="title-font">Top Features</div>
          <ul className="features-list col-2">
             <li>
                <div className="icon feature-icon">
                   <img src={interactive} alt=""/>
                </div>
                <div className="feature-title rubik-medium">Interactive</div>
                <div className="feature-desc">
                   Your viewers can annotate and leave a comment anywhere on the video
                </div>
             </li>
             <li>
                <div className="icon feature-icon">
                   <img src={insert} alt=""/>
                </div>
                <div className="feature-title rubik-medium">Insert Calls-To-Action</div>
                <div className="feature-desc">
                   Guide your users to take further action via customizable calls-to-action buttons
                </div>
             </li>
             <li>
                <div className="icon feature-icon">
                   <img src={embed} alt=""/>
                </div>
                <div className="feature-title rubik-medium">Embed anywhere</div>
                <div className="feature-desc">
                   Embed interactive demos and videos anywhere on your website, social media or email.
                </div>
             </li>
             <li>
                <div className="icon feature-icon">
                   <img src={code} alt=""/>
                </div>
                <div className="feature-title rubik-medium">No-code builder</div>
                <div className="feature-desc">
                   Create interactive videos and demos in seconds. Tailor to your needs and goals like a pro.
                </div>
             </li>
          </ul>
       </div>
   )
}

export default UseCaseFeatures
